<template>
    <div>
        <!-- Add new address -->
        <div @click="displayNewAddressForm = true" :class="!displayNewAddressForm ? 'hover:bg-gray-100 duration-200 cursor-pointer' : ''" class="p-6 my-4 bg-white border border-gray-200 my-rounded">
            <div test-id="button-new-address" v-if="!displayNewAddressForm">
                <i class="mr-2 fas fa-plus-circle"></i>{{$t('parametres.addresses.ajouter_une_adresse')}}
            </div>
            <div v-if="displayNewAddressForm">
                <div class="text-right">
                    <button @click.stop="displayNewAddressForm = false" class="px-3 py-2 text-sm font-light text-gray-700 text-red-500 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <sav-map-input :map="false" class="mt-2" @input="saveAddressInAccount" />
            </div>
        </div>

        <!-- Addresses list -->
        <div v-if="addresses">
            <div
            v-for="(address, addressIndex) in addresses"
            :key="'address-' + addressIndex"
            :test-id="'address-list-' + addressIndex"
            >
                <address-update-card :user="user" :address="address" />
            </div>
        </div>
    </div>
</template>

<script>
import AddressTool from '@/tools/AddressTool'
import UpdateCard from './../components/UpdateCard.vue'
import AddressUpdateCard from '../components/AddressUpdateCard.vue'
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'

export default {
    components: {UpdateCard, AddressUpdateCard},
    props: {
        user: {
            required: true
        }
    },
    watch: {
        user: {
            deep: true,
            handler(value) {
                this.setAddresses()
            }
        }
    },
    data() {
        return {
            addresses: null,
            displayNewAddressForm: false
        }
    },

    methods: {
        setAddresses() {
            this.addresses = this.user.list_address.map(address => ({...address, edit: false, fullAddress: AddressTool.convertSav(address)}))
        },

        async saveAddressInAccount(address) {
            var user = await apiService.getUser()
            await apiService.post('add_address', {
                id_conso: user.id,
                nom: address.nom,
                prenom: address.prenom,
                adresse1: address.adresse1,
                adresse2: address.adresse2,
                cp: address.cp,
                ville: address.ville,
                longitude: address.longitude,
                latitude: address.latitude
            })
            this.displayNewAddressForm = false
            eventHub.$emit('refresh-user')
        },
    },

    mounted() {
        this.setAddresses()
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/settings/AddressSettingsSection.vue